import React, { useState } from "react";
import { RunnerUpHeader } from "../../../ui";
import SelectField from "../../../library/components/Select/index";
import { useGetEpbDownloadPhasewiseEciReportMutation, useGetEpbPrecountingSummaryEciReportMutation } from "../../../services/reportsServices";
import "./countingsupervisoreciofficer.css";
import { Validators } from "../../../library/utilities/Validator";
import { downloadExcelFile, downloadPdfFile } from "../../utilities/utils"
import pdfIcon from "../../../images/pdfIcon.png"
import excelIcon from "../../../images/excelIcon.png"
import Table from "../../../ui/datatable/DataTable";
import LeftMenu from "../../AnalyticsModule/Left";
import RunnerUpHeaderNew from "../../../ui/runnerUpHeader/RunnerUpHeaderNew";

const tableHeader = [
  "State Name",
  "Election Type",
  "Constituency Type",
  "Total Constituency",
  "e-PB Pre-Counting Completed",
  "e-PB Pre-Counting Pending",
  "Total e-PB Received Till 8 AM",
  "Total e-PB Received After 8 AM",
  "Total e-PB Rejected Without Scanning"
];


const EpbPrecountingSummaryreport = () => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const reportName = "e-Postal Ballot Pre-Counting Summary Report"
  const SheetName = "State Wise Report"

  const [Error, setError] = useState({});
  const [tableData, setTableData] = useState([]);
  const constType = [
    { value: "", label: "Select Constituency" },
    { value: "AC", label: "AC" },
    { value: "PC", label: "PC" },
  ];
  const tableHeader = [];
  const columns = [
    {
      Header: "State Name",
      accessor: "col1",
    },
    {
      Header: "Election Type",
      accessor: "col2",
    },
    {
      Header: "Constituency Type",
      accessor: "col3",
    },
    {
      Header: "Total Constituency",
      accessor: "col4",
    },
    {
      Header: "e-PB Pre-Counting Completed",
      accessor: "col5",
    },
    {
        Header: "e-PB Pre-Counting Pending",
        accessor: "col6",
      },
   
      {
        Header: "Total e-PB Received Till 8 AM",
        accessor: "col7",
      },
      {
        Header: "Total e-PB Received After 8 AM",
        accessor: "col8",
      },
      {
        Header: "Total e-PB Rejected Without Scanning",
        accessor: "col9",
      },
  ];
  columns.map((item)=>{
    tableHeader.push(item.Header)
  })
  const [states, setStates] = useState({
    stateValue:"",
    constTypeValue:"",
  });

  const [saveData, datap] = useGetEpbPrecountingSummaryEciReportMutation()

  // getElectionAnnouncedState?.payload?.map((item) => {
  //   stateList?.push({
  //     value: item.stateCd,
  //     label: item.stateName,
  //   });
  // });

  const handleChange = (key, value) => {
    setStates((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const getError = (key, value) => {
    let error = { ...Error };
    if (value && value.message) {
      setError({ ...Error, [key]: value.message });
    } else {
      delete error[key];
      setError(error);
    }
  };

  const renderTableData = () => {
    let error = {};
    if (!states.constTypeValue || states.constTypeValue === "") {
      error["constTypeValue"] = "This Field is required"
    }
    if (Object.keys(error).length) {
      setError(error);
      return;
    }

    let payload = {
      "constType": states.constTypeValue
    }
    

    saveData(payload)
      .unwrap()
      .then((res) => {
        let tData = []
        res?.payload?.map((item) => {
            tData.push({
                "col1": item.stateName,
                "col2": item.electionType,
                "col3": item.constType,
                "col4": item.total_constituency,
                "col5": item.total_scanning_completed,
                "col6": item.pending,
                "col7": item.epb_Receiceived_Till_8AM,
                "col8": item.epb_Receiceived_After_8AM,
                "col9": item.total_Epb_Rejected_Without_Scan,
              });
        });
        setTableData(tData)
        setTotalNoOfRecords(res?.payload?.length)
      }).catch((error) => {
        if(error?.data?.message==="No record found")
        {
          
          setTableData([])
        }
      })
  };
  return (
    <>
    <LeftMenu>
      <div className="container box shadow ">
      <div className="row">
          <div className="col-md-12">
            <RunnerUpHeaderNew title={reportName} 
            onPdfClick={() => downloadPdfFile(`${reportName} (${states.constTypeValue})`, tableHeader, tableData , false, true)}
                onExcelClick={() => downloadExcelFile(`${reportName} (${states.constTypeValue})`, SheetName, tableHeader, tableData)}/>
          </div>
        </div>
        <div className="row">
          <SelectField
            labelClass=""
            inputClass="col-md-2 pr-1"
            value={states.constTypeValue}
            name="constTypeValue"
            handleChange={(val) => handleChange("constTypeValue", val)}
            options={constType}
            validators={[
              {
                check: Validators.required,
                message: "This field is required",
              }
            ]}
  
            getError={(val) => getError("constTypeValue", val)}
            Error={Error}
          />
          <div className="col-md-2 ">
          <button
              type="button"
              className="btn btn-primary btn-sm searchbuttonreport"
              onClick={renderTableData}>
              VIEW
              <span className="pl-2">
                <i class="fa fa-eye">
                </i>
              </span>
            </button>
          </div>
        </div>
        <div style={{marginTop:"-4px"}}>
        <Table
              placeholder="Search"
              globalsearch={true}
              selectall={true}
              columns={columns}
              emptyMessage="No Record Found"
              data={tableData?.length === 0 ? [] : tableData}
              size={5}
              tableClassNameCheck="contenttable-eroll"
              pagination  
              records
              gotopage
              rows
              numberrows={totalNoOfRecords}
            />
        </div>
      </div>
      </LeftMenu>
    </>
  );
};

export default EpbPrecountingSummaryreport;
